// extracted by mini-css-extract-plugin
export default {"heading":"DatingPreference_heading__tpBHI","error":"DatingPreference_error__pEZ2S","closeIcon":"DatingPreference_closeIcon__PWcwP"};